(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1188],{

/***/ 37988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var antd_lib_collapse_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70643);
/* harmony import */ var antd_lib_collapse_style__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(antd_lib_collapse_style__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var antd_lib_collapse__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68469);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30080);
/* harmony import */ var _src_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74183);
/* harmony import */ var react_icons_go__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8704);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);








function FrequentQuestions() {
  var Panel = antd_lib_collapse__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Panel */ .Z.Panel;

  var _useToolkit = (0,_src_components__WEBPACK_IMPORTED_MODULE_1__/* .useToolkit */ .Oc)(),
      isMobile = _useToolkit.isMobile;

  var faqItems = [{
    id: Math.random(),
    headerText: "What are the security features of Qwid",
    answers: ["Password-Protected", "2FA-Protected", "Pin-Protected (coming soon)"]
  }, {
    id: Math.random(),
    headerText: "How do you keep your rates updated",
    answers: ["Our rates are updated automatically at every point of value input."]
  }, {
    id: Math.random(),
    headerText: "Do you have plans to expand to other currencies",
    answers: ["Yes, we are currently working on expanding to more currencies so you can make payments to more countries in real-time."]
  }, {
    id: Math.random(),
    headerText: "Can I have multiple Qwid accounts",
    answers: ["Yes, but other accounts must be created with different emails. However, we highly recommend sticking to one account."]
  }, {
    id: Math.random(),
    headerText: "What are the transaction limits on my account",
    answers: ["You can find your stipulated transaction limits on your Qwid dashboard."]
  }, {
    id: Math.random(),
    headerText: "How long does it take to be verified",
    answers: ["Depending on the document supplied, most verification processes should be approved immediately however, it can be under review until our compliance team makes a decision."]
  }, {
    id: Math.random(),
    headerText: "Where can I use my Virtual cards",
    answers: ["Virtual cards can be used anywhere either in subscription mode, payment mode, or others."]
  }, {
    id: Math.random(),
    headerText: "What are the transaction fees",
    answers: ["Our transaction fees vary based on the type of transaction, currency, and country. However, we ensure competitive and affordable rates"]
  }, {
    id: Math.random(),
    headerText: "How long does it take for payments to reflect",
    answers: ["Transfer to a virtual account should reflect immediately but the delay might come from the sender's bank. ", "Remittance reflect based on the type of account the beneficiary has, some reflect instantly and some take T+2 days as the maximum time frame."]
  }, {
    id: Math.random(),
    headerText: "What do I do in case of an erroneous transfer",
    answers: ["You can always send us an email to our customer care ( support@qwid.io ) or support, we will receive the error and get it rectified or possibly explain the status of the error to the user."]
  }];

  function customHeader(title) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: "w-full flex-btw",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("p", {
        className: "mb-0 med lg:text-lg pl-2",
        children: [title, "?"]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_4__/* .MdOutlineAddBox */ .om2, {
        className: "pry-text",
        size: "1.5rem"
      })]
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_src_components__WEBPACK_IMPORTED_MODULE_1__/* .LandingLayout */ .a2, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: "bg-[#E5E5E5] py-28",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "mb-10 lg:mb-12 tcent",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
          className: "mb-7 text-2xl lg:text-6xl blk tracking-wide smb",
          children: "Frequently Asked Questions"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
          className: "med smb mb-0 lg:text-lg px-10 lg:px-0 tcent",
          children: "We answer basic questions you may have so you don't have to wonder!"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        className: "lg:w-4/5 mx-auto p-6",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(antd_lib_collapse__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          style: {
            background: "#fff",
            padding: isMobile ? "30px" : "60px",
            paddingBottom: "15px"
          },
          accordion: true,
          expandIconPosition: "end",
          defaultActiveKey: ["2"],
          children: faqItems.map(function (_ref) {
            var id = _ref.id,
                headerText = _ref.headerText,
                answers = _ref.answers;
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Panel, {
              style: {
                backgroundColor: "#fff",
                padding: isMobile ? "" : "10px 8px",
                marginBottom: "25px",
                border: "1px solid #bbb",
                borderRadius: "6px"
              },
              showArrow: false,
              header: customHeader(headerText),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                className: "text-sm lg:w-4/5",
                children: answers === null || answers === void 0 ? void 0 : answers.map(function (item) {
                  return answers.length > 1 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("p", {
                    className: "mbs-3 flex items-start",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_go__WEBPACK_IMPORTED_MODULE_5__/* .GoDotFill */ .Zh5, {}), "\xA0", item]
                  }, item) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
                    className: "mbs-3",
                    children: item
                  }, item);
                })
              })
            }, id);
          })
        })
      })]
    })
  });
}

/* harmony default export */ __webpack_exports__["default"] = (FrequentQuestions);

/***/ }),

/***/ 85860:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faqs",
      function () {
        return __webpack_require__(37988);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(85860); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);